export enum SAWWheelLayout {
    Centered = 1,
    LeftAligned = 2,
    RightAligned = 3,
    BottomAligned = 4,
}